'use client'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'

interface SectionHeaderProps {
  title: string
  subtitle?: string
  actions?: ReactNode
  /** 'page' renders the title as h1 (top of a page); 'section' as h4. */
  level?: 'page' | 'section'
}

export default function SectionHeader({
  title,
  subtitle,
  actions,
  level = 'section',
}: SectionHeaderProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: subtitle ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        mb: 3,
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant={level === 'page' ? 'h1' : 'h4'}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Stack>
      {actions && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  )
}
